import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {DisplayTypeTableComponent} from './table/display-type-table.component';
import {DisplayTypeEditComponent} from './edit/display-type-edit.component';
import {DisplayTypeCreateComponent} from './create/display-type-create.component';

@NgModule({
  declarations: [
    DisplayTypeTableComponent,
    DisplayTypeEditComponent,
    DisplayTypeCreateComponent
  ],
  imports: [SharedModule],
  exports: [
    DisplayTypeTableComponent,
    DisplayTypeEditComponent,
    DisplayTypeCreateComponent
  ]
})
export class DisplayTypeModule {}
